(function($){
  $(function(){
    if(!navigator.userAgent.match(/(iPhone|iPad|iPod|Android)/)){
      $(".sub-menu").css('display', 'none');
    }
    // スマホ トグルメニュー
    var gNav = $('#gnav')
    if(gNav.length) {
      gNav.removeClass('active')
      $('#header-menu-tog a').on('click', function(){
        gNav.toggleClass('active')
        var gnavContainerHeight = $('#gnav-container').outerHeight(true)
        var subContainerHeight = $('#sub-container_sp').outerHeight(true)
        if(gNav.hasClass('active')) {
          // activeクラスが適用されている場合は除外
          gNav.css( 'height', gnavContainerHeight + subContainerHeight + 'px' )
        } else {
          gNav.css( 'height', '0px' )
        }
      })
    }
  })
})(jQuery)
